export const SPEC = "SPEC";
export const COM = "COM";
